// Third-party
import React from 'react';

// Components
import DefaultModal from './DefaultModal';

// Utils
import { formatMessage } from '../../../utils/i18n';

type Props = {
  show: boolean;
  onConfirm: () => void;
  onDecline: () => void;
  onCancel: () => void;
};

const SavePortfolioModal = ({ show, onConfirm, onDecline, onCancel }: Props) => {
  const body = <p>{formatMessage('Portfolios.SavePortfolioModal.Body')}</p>;

  return (
    <DefaultModal
      show={show}
      title={formatMessage('Portfolios.SavePortfolioModal.Title')}
      body={body}
      onConfirm={onConfirm}
      confirmLabel={formatMessage('Portfolios.SavePortfolioModal.Confirm')}
      onSecondaryAction={onDecline}
      secondaryActionLabel={formatMessage('Portfolios.SavePortfolioModal.Decline')}
      onCancel={onCancel}
    />
  );
};

export default SavePortfolioModal;
